export default "__VITE_ASSET__8501c0dc__"